import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';
import { media } from '../../../common/styles/styleUtil';

interface PhoneNumberProps {
  isShowFullPhoneNumber?: boolean;
}
export const LeadCaptureWrapper = styled.div`
  .title {
    text-align: center;
    margin-top: 32px;
  }
  .buttons {
    margin: 16px auto 24px;
    ${media.xs`
      display: flex;
      justify-content: space-between;
      margin:16px 16px 24px;
   `}
    .form-button {
      display: none;
      ${media.xs`
       display: inline-block;
       color: #ffffff;
       width: 167px;
       height: 48px;
       line-height:48px;
       border-radius: 3px;
       background-color: #c20014;
       text-align:center;
   `}
      .mail {
        margin-right: 2px;
      }
    }
    .contact-button {
      width: 165px;
      height: 40px;
      line-height: 40px;
      background-color: #e9ebed;
      text-align: center;
      margin: 0 auto;
      a {
        color: #333f48;
        text-decoration: none;
        display: flex;
        justify-content: center;
      }
      ${media.xs`
       height: 48px;
       width: 167px;
       margin:0;
    `}
      .phone {
        margin-right: 2px;
        transform: rotate(90deg);
      }
    }
  }
  .lead-form {
    ${media.xs`
      display: none;
   `}
  }
`;

export const PhoneNumber = styled.div<PhoneNumberProps>`
  ${ifProp(
    { isShowFullPhoneNumber: false },
    css`
      width: 35%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    `,
  )}
`;

export const ModalForm = styled.div`
  display: none;
  ${media.xs`
      display: inline-block;
   `}
`;

export const ModalFormBody = styled.div`
  .modal-title {
    padding: 32px 88px 0;
    text-align: center;
  }
  .modal-contact-button {
    width: 104px;
    height: 40px;
    line-height: 40px;
    background-color: #e9ebed;
    text-align: center;
    margin: 16px auto 0;
    a {
      color: #333f48;
      text-decoration: none;
    }
    .phone {
      margin-right: 2px;
      transform: rotate(90deg);
    }
  }
`;
